"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categorySelected = void 0;
var constants_1 = require("../constants");
exports.categorySelected = function (_a) {
    var _b;
    var category = _a.category, session = _a.session;
    var props = (_b = {},
        _b[constants_1.EventProperty.SELECTED_CATEGORY] = category,
        _b[constants_1.EventProperty.USER_ID] = session.userID,
        _b[constants_1.EventProperty.CUSTOMER_NAME] = session.customer,
        _b);
    window.analytics.track(constants_1.EventName.CATEGORY_SELECTED, props);
};
